import encryptDecrypt from '../../cryptography/encryptDecrypt';
import config from '../../../config/config';
import moment from 'moment';
import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;
        const {
            companyId='', inhouz_reserved_parameters_xyzh={}, user={}
        } = parameterObject;
        const {appEnvironment=''} = inhouz_reserved_parameters_xyzh;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        if(parsedParameters.error){
            variableObject[variableName] = {
                error : {
                    message : 'Failed to parse function parameters.'
                }
            }
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let variableCopy = parsedParameters['variableObject'];
        let resolvedParams = parsedParameters['accumulator'];

        let filter = {
            _id : resolvedParams['documentId'] || '',
            documentName : resolvedParams['documentName'] || '',
            projectId : resolvedParams['projectId'] || '',
            status : (resolvedParams['status'] && resolvedParams['status'].toLowerCase()) || '',
            createdByEmail : resolvedParams['createdByEmail'] || '',
            recipientEmail : resolvedParams['recipientEmail'] || '',
            environment : appEnvironment
        }

        if(
            resolvedParams['createdFromTimestamp'] && 
            typeof resolvedParams['createdFromTimestamp'] === 'number'
        ){
            filter['createTimestamp'] = {
                '$gte' : resolvedParams['createdFromTimestamp']
            }
        }

        if(
            resolvedParams['createdFromTimestamp'] && 
            typeof resolvedParams['createdFromTimestamp'] === 'number'
        ){
            if(!filter['createTimestamp']){
                filter['createTimestamp'] = {};
            }
            filter['createTimestamp'] = {
                ...filter['createTimestamp'],
                '$lte' : resolvedParams['createdToTimestamp']
            }
        }

        if(
            resolvedParams['updateFromTimestamp'] && 
            typeof resolvedParams['updateFromTimestamp'] === 'number'
        ){
            filter['updateTimestamp'] = {
                '$gte' : resolvedParams['updateFromTimestamp']
            }
        }

        if(
            resolvedParams['updateToTimestamp'] && 
            typeof resolvedParams['updateToTimestamp'] === 'number'
        ){
            if(!filter['updateTimestamp']){
                filter['updateTimestamp'] = {};
            }
            filter['updateTimestamp'] = {
                ...filter['updateTimestamp'],
                '$lte' : resolvedParams['updateToTimestamp']
            }
        }

        let sort = {};
        if(resolvedParams['sortByDocumentName']){
            sort['documentName'] = 1;
        }
        if(resolvedParams['sortByStatus']){
            sort['status'] = 1;
        }
        if(resolvedParams['sortByCreateTimestamp']){
            sort['createTimestamp'] = 1;
        }
        if(resolvedParams['sortByUpdateTimestamp']){
            sort['updateTimestamp'] = 1;
        }

        let payload = {
            filter,
            sort,
            limit : resolvedParams['limit'],
            skip : resolvedParams['skip'],
            companyId,
            functionGenerated : true,
            queryEnvironment : appEnvironment,
            queryKey : `${Math.random()}${Math.random()}${Math.random()}${Math.random()}`
        }

        let encryptedPayload = encryptDecrypt(
            JSON.stringify({
                payload,
                expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
            }),
            true
        );

        let encryptedAccessHeader = '', clientEncryptedApiHeader='';
        if(resolvedParams['X-API-KEY']){
            clientEncryptedApiHeader = encryptDecrypt(
                JSON.stringify({
                    payload : {
                        'X-API-KEY' : resolvedParams['X-API-KEY'],
                        companyId,
                        queryKey : `${Math.random()}${Math.random()}${Math.random()}${new Date().getTime()}`,
                        environment : appEnvironment
                    },
                    expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
                }),
                true
            );
        }else{
            if(user && user.isAuthenticated){
                encryptedAccessHeader = encryptDecrypt(
                    JSON.stringify({
                        payload : {
                            assetOwnerCompanyId : companyId,
                            companyId : user['companyId'],
                            email : user['email'],
                            subscriptionId : user['subscriptionId'],
                            subscriptionServiceId : user['subscriptionServiceId'],
                            environment : appEnvironment,
                            _id : user['_id'],
                            userId : user['_id'],
                            isInternal : (user['subscriberType'] === 'internal') || user['isInternal'] ? true : false,
                            isSystemUser : user['isSystemUser'] ? true : false
                        },
                        expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
                    }),
                    true
                );
            }
        }

        let response = await fetch(
            `${config.devServerProxy}/api/inhouzsign/document/getdocuments`,
            {
                method : 'POST',
                headers : {
                    'Accept':"application/json",
                    'Content-Type':"application/json",
                    'Cache': 'no-cache',
                    'clientEncryptedAccessHeader' : encryptedAccessHeader,
                    'X-CE-API-KEY' : clientEncryptedApiHeader
                },
                credentials : 'omit',
                body : JSON.stringify({
                    encryptedPayload
                })
            }
        )
        .then(resp => resp.json())
        .catch((error) => {
            return {
                error : {
                    message : error.message
                }
            }
        });

        variableCopy[variableName] = response;
        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/getInhouzSignDocumentsParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}